import React from 'react';
import * as PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import _ from 'lodash';
import Constants from '../../config/constants';

class SearchBar extends React.Component {
  constructor(props) {
    super(props);
    this.onSearch = _.debounce(this.onSearch, Constants.DEBOUNCE_TIME);
  }

  onSearch(value) {
    const onSearch = this.props.onSearch;
    if (onSearch) {
      onSearch(value);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <div style={{ display: 'flex', padding: 20, marginBottom: 10 }}>
        <div className="filter-box">
          <input
            id="zone-search-name"
            className="text-search"
            type="text"
            onChange={event => this.onSearch(event.target.value)}
            placeholder={t('search name')}
          />
        </div>
        {this.props.auxiliaryButton}
      </div>
    );
  }
}

SearchBar.propTypes = {
  onSearch: PropTypes.func,
  placeholder: PropTypes.any,
  onClick: PropTypes.func,
  auxiliaryButton: PropTypes.any,
};

export default translate('translations')(
  SearchBar
);



// WEBPACK FOOTER //
// ./src/components/datatable/SearchBar.js